export const FETCH_PRIZE = 'FETCH_PRIZE';
export const FETCH_PRIZE_SUCCEED = 'FETCH_PRIZE_SUCCEED';
export const FETCH_PRIZE_FAILED = 'FETCH_PRIZE_FAILED';

export const CREATE_PRIZE = 'CREATE_PRIZE';
export const CREATE_PRIZE_SUCCEED = 'CREATE_PRIZE_SUCCEED';
export const CREATE_PRIZE_FAILED = 'CREATE_PRIZE_FAILED';

export const UPDATE_PRIZE = 'UPDATE_PRIZE';
export const UPDATE_PRIZE_SUCCEED = 'UPDATE_PRIZE_SUCCEED';
export const UPDATE_PRIZE_FAILED = 'UPDATE_PRIZE_FAILED';

export const FETCH_LUCKY_GAME_CONFIG = 'FETCH_LUCKY_GAME_CONFIG';
export const FETCH_LUCKY_GAME_CONFIG_SUCCEED = 'FETCH_LUCKY_GAME_CONFIG_SUCCEED';
export const FETCH_LUCKY_GAME_CONFIG_FAILED = 'FETCH_LUCKY_GAME_CONFIG_FAILED';
